import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { t } from 'i18next'

import Panel from '~/components/Panel'

import RetailMediaExternalReport from '../Report'

// import { Container } from './styles';

const MetricsBySubpublisher: React.FC = () => {
  const { id: campaign_id } = useParams() as { id: CampaignId }

  const query = useMemo(
    () => ({
      campaign_id
    }),
    [campaign_id]
  )

  return (
    <Panel
      title={t('rm:campaign.subpublishers.metrics.title')}
      noPaddingBody
      isCollapsible
      initialCollapsibleState={false}
      unmountContentIfCollapse
    >
      <section style={{ height: 'clamp(400px, 95vh, 1400px)' }}>
        <RetailMediaExternalReport
          useDate
          customFilters={query}
          dashboardName="campaigns_by_subpublisher"
        />
      </section>
    </Panel>
  )
}

export default MetricsBySubpublisher
